import PropTypes from 'prop-types';
import React from 'react'
import createReactClass from 'create-react-class';
import { withRouter } from 'react-router-dom'
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';

import { seenNotification } from '~/actions/notifications'


const Alerts = createReactClass({

	notifications_sent: [],

	propTypes: {
		notifications: PropTypes.array,
		history: PropTypes.object
	},

	componentDidUpdate: function(prevProps, prevState) {

		if( !this.props.notifications.length ) return;

		for (var i = 0; i < this.props.notifications.length; i++) {
			let this_notification = this.props.notifications[i];
			if( this.notifications_sent.indexOf( this_notification.created_date ) === -1 ) {
				this.notifications_sent.push( this_notification.created_date )
				this.createVisibleNotification( this_notification )
			}
		}

	},

	clickNotification: function(link) {
		if( link ) this.props.location.push(link);
	},

	createVisibleNotification: function(notification) {
		NotificationManager[notification.type](notification.text, '', 5000, this.clickNotification.bind(this, notification.link));
	},

	render: function() {
		return (
			<NotificationContainer />
		)
	}
	
})

const mapStateToProps = state => ({
    notifications: state.notifications.visible
});

export default connect(
    mapStateToProps,
    null
)( withRouter(Alerts) );



// WEBPACK FOOTER //
// ./src/js/components/Alerts/index.js